<template>
    <li v-if="folder">
        <router-link :to="{ name: 'messages.listing', params: folder }">
            <i :class="folderClass"></i>
            <font-awesome-icon class="mr-2" :icon="folderClass" />
            {{ translateFolderName(folder) }}
            <span v-if="showUnread" class="badge otu-blue-bg ml-auto float-right p-2 text-white">{{folder.unread_count}}</span>
        </router-link>
    </li>
</template>

<script>
export default {
    name: 'Folders',
    props: {
        folder: {
            type: Object,
            type_id: 0,
            unread_count: 0,
            name: ''
        }
    },
    computed: {
        folderClass () {
            switch(this.folder.type_id) {
                case 40:
                    return ['fas', 'inbox'];
                case 30:
                    return ['far', 'paper-plane'];
                case 20:
                    return ['far', 'edit'];
                case 10:
                    return ['far', 'trash-alt'];
                default:
                    return ['far', 'folder'];
            }
        },
        showUnread: function () {
            return this.folder.unread_count > 0 && this.folder.type_id == 40;
        }
    },
    methods: {
        translateFolderName (folder) {
            return (folder.type_id > 0) ? this.$t('messages.folders.'+folder.type_id) : folder.name;
        }
    }
}
</script>
